module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"addAnswer":"Antwort hinzufügen","cancel":"Abbrechen","question":"Frage","save":"Speichern","text":"Text"},"en":{"addAnswer":"Add answer","cancel":"Cancel","question":"Question","save":"Save","text":"Text"}}')
  delete Component.options._Ctor
}
